/**
 * Staff status pill.
 *
 * IMPORTANT: the UI copy must match Randy's final public verify strings
 * — "active" in the admin view, but when shown publicly on the verify
 * page, it's "verified". We're ONLY showing the admin view here, so the
 * labels are what the admin understands: Active, Suspended, Left.
 *
 * The public verify page (Chunk 2C) will use Randy's strings:
 *   under_review (for suspended) / no_longer_employed (for left)
 */

const STATUS_LABELS = {
  active:    'Active',
  suspended: 'Suspended',
  left:      'Left',
};

const STATUS_CLASSES = {
  active:    'status-pill-active',
  suspended: 'status-pill-suspended',
  left:      'status-pill-left',
};

export function StatusPill({ status }) {
  const label = STATUS_LABELS[status] || status || 'Unknown';
  const cls = STATUS_CLASSES[status] || 'status-pill-left';
  return <span className={`status-pill ${cls}`}>{label}</span>;
}
